<div class="flex flex-col gap-5">
  @for (item of [1, 2, 3, 4, 5]; track item) {
  <div class="flex items-center gap-2">
    <div class="w-8 h-8 bg-grey-skeleton rounded-full animate-pulse"></div>
    <div class="h-5 grow bg-grey-skeleton rounded-16 animate-pulse"></div>
    @if(isIcon()) {
    <div class="w-5 h-5 bg-grey-skeleton rounded-full animate-pulse"></div>
    }
  </div>
  }
</div>
